'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var b16 = require('../typography/b16.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  font-family: Source Sans Pro, sans-serif;\n  width: ", ";\n  height: ", ";\n  box-shadow: ", ";\n  background-color: white;\n  padding: ", ";\n  margin: ", ";\n  text-align: ", ";\n  border-radius: 5px;\n  overflow: hidden;\n  @media screen and (max-width: 991px) {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"], ["\n  font-family: Source Sans Pro, sans-serif;\n  width: ", ";\n  height: ", ";\n  box-shadow: ", ";\n  background-color: white;\n  padding: ", ";\n  margin: ", ";\n  text-align: ", ";\n  border-radius: 5px;\n  overflow: hidden;\n  @media screen and (max-width: 991px) {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  max-width: 100%;\n  overflow: hidden;\n  margin: ", ";\n  text-align: center;\n"], ["\n  max-width: 100%;\n  overflow: hidden;\n  margin: ", ";\n  text-align: center;\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  object-fit: contain;\n  width: auto;\n  max-width: 100%;\n"], ["\n  object-fit: contain;\n  width: auto;\n  max-width: 100%;\n"]);

var CardContainer = styled__default.div(_templateObject, function (props) {
  return props.width || "293px";
}, function (props) {
  return props.height || "auto";
}, function (props) {
  return !props.noShadow && settings.CHECKBOX_NORMAL_SHADOW;
}, function (props) {
  return props.padding || "20px";
}, function (props) {
  return props.margin || "0px";
}, function (props) {
  return props.align || "center";
}, function (props) {
  return props.mWidth && "width: " + props.mWidth + ";";
}, function (props) {
  return props.mHeight && "height: " + props.mHeight + ";";
}, function (props) {
  return props.mPadding && "padding: " + props.mPadding + ";";
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin + ";";
});

var ImgContainer = styled__default.div(_templateObject2, function (props) {
  return props.imgPosition === "BOTTOM" ? "20px 0 0 0" : "0 0 20px 0";
});

var Img = styled__default.img(_templateObject3);

var BenefitCard = function BenefitCard(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === undefined ? "" : _ref$description,
      _ref$element = _ref.element,
      element = _ref$element === undefined ? null : _ref$element,
      _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === undefined ? "" : _ref$imgSrc,
      _ref$imgStyle = _ref.imgStyle,
      imgStyle = _ref$imgStyle === undefined ? {} : _ref$imgStyle,
      _ref$align = _ref.align,
      align = _ref$align === undefined ? "center" : _ref$align,
      _ref$imgPosition = _ref.imgPosition,
      imgPosition = _ref$imgPosition === undefined ? "TOP" : _ref$imgPosition,
      props = _babelHelpers.objectWithoutProperties(_ref, ["title", "description", "element", "imgSrc", "imgStyle", "align", "imgPosition"]);
  return React__default.createElement(
    CardContainer,
    _babelHelpers._extends({ align: align }, props),
    imgSrc && imgPosition === "TOP" && React__default.createElement(
      ImgContainer,
      { style: imgStyle, imgPosition: imgPosition },
      React__default.createElement(Img, { src: imgSrc, alt: "" })
    ),
    title && React__default.createElement(
      b16.default,
      { weight: 600, size: "20px", margin: "0 0 10px 0", lineHeight: "26px" },
      title
    ),
    description && React__default.createElement(
      b16.default,
      { size: "14px", margin: "0 0 10px 0", lineHeight: "20px" },
      description
    ),
    !!element && element,
    imgSrc && imgPosition === "BOTTOM" && React__default.createElement(
      ImgContainer,
      { style: imgStyle, imgPosition: imgPosition },
      React__default.createElement(Img, { src: imgSrc, alt: "" })
    )
  );
};
BenefitCard.propTypes = {
  /** title text */
  title: PropTypes$1.string,
  /** description text */
  description: PropTypes$1.string,
  /** foter section */
  element: PropTypes$1.node,
  /** image src */
  imgSrc: PropTypes$1.string,
  /** custom image container style */
  imgStyle: PropTypes$1.shape({}),
  /** text align */
  align: PropTypes$1.oneOf(["left, center, right"]),
  /** postion of image */
  imgPosition: PropTypes$1.oneOf(["TOP", "BOTTOM"])
};
BenefitCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BenefitCard",
  "props": {
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title text"
    },
    "description": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "description text"
    },
    "element": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "foter section"
    },
    "imgSrc": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "image src"
    },
    "imgStyle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "custom image container style"
    },
    "align": {
      "defaultValue": {
        "value": "\"center\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"left, center, right\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "text align"
    },
    "imgPosition": {
      "defaultValue": {
        "value": "\"TOP\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"TOP\"",
          "computed": false
        }, {
          "value": "\"BOTTOM\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "postion of image"
    }
  }
};

exports.BenefitCard = BenefitCard;
exports.default = BenefitCard;
//# sourceMappingURL=benefit-card.js.map
